import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed",
  style: {"background-image":"url('media/illustrations/progress-hd.png')"}
}
const _hoisted_2 = { class: "d-flex flex-center flex-column flex-column-fluid p-0 p-md-10 pb-lg-20" }
const _hoisted_3 = { class: "w-lg-500px bg-white rounded shadow-sm p-10 p-lg-15 mx-auto" }
const _hoisted_4 = { class: "text-center mb-10" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h1", { class: "text-dark mb-3" }, " Sign In to W.E ApS ", -1)
const _hoisted_6 = { class: "text-gray-400 fw-bold fs-4" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" New Here? ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Create an Account")
const _hoisted_9 = { class: "fv-row mb-10" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fs-6 fw-bolder text-dark" }, "Email", -1)
const _hoisted_11 = { class: "fv-plugins-message-container" }
const _hoisted_12 = { class: "fv-help-block" }
const _hoisted_13 = { class: "fv-row mb-10" }
const _hoisted_14 = { class: "d-flex flex-stack mb-2" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-6 mb-0" }, "Password", -1)
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Forgot Password ? ")
const _hoisted_17 = { class: "fv-plugins-message-container" }
const _hoisted_18 = { class: "fv-help-block" }
const _hoisted_19 = { class: "text-center" }
const _hoisted_20 = ["disabled", "data-kt-indicator"]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Continue ", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Please wait... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_23 = [
  _hoisted_21,
  _hoisted_22
]
const _hoisted_24 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex flex-center flex-column-auto p-10\"><div class=\"d-flex align-items-center fw-bold fs-6\"><a href=\"#\" class=\"text-muted text-hover-primary px-2\">About</a><a href=\"#\" class=\"text-muted text-hover-primary px-2\">Contact</a><a href=\"#\" class=\"text-muted text-hover-primary px-2\">Contact Us</a></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!
  const _component_OtpInput = _resolveComponent("OtpInput")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (!_ctx.requireOtp)
          ? (_openBlock(), _createBlock(_component_Form, {
              key: 0,
              class: "form w-100",
              id: "kt_login_signin_form",
              onSubmit: _ctx.onSubmitLogin,
              "validation-schema": _ctx.login
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _hoisted_5,
                  _createElementVNode("div", _hoisted_6, [
                    _hoisted_7,
                    _createVNode(_component_router_link, {
                      to: "/sign-up",
                      class: "link-primary fw-bolder"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_8
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _createVNode(_component_Field, {
                    class: "form-control form-control-lg form-control-solid",
                    type: "text",
                    name: "email",
                    autocomplete: "off"
                  }),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createVNode(_component_ErrorMessage, { name: "email" })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _hoisted_15,
                    _createVNode(_component_router_link, {
                      to: "/password-reset",
                      class: "link-primary fs-6 fw-bolder"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_16
                      ]),
                      _: 1
                    })
                  ]),
                  _createVNode(_component_Field, {
                    class: "form-control form-control-lg form-control-solid",
                    type: "password",
                    name: "password",
                    autocomplete: "off"
                  }),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _createVNode(_component_ErrorMessage, { name: "password" })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("button", {
                    type: "submit",
                    ref: "submitButton",
                    disabled: _ctx.loading,
                    "data-kt-indicator": _ctx.loading ? 'on' : 'off',
                    class: "btn btn-lg btn-primary w-100 mb-5"
                  }, _hoisted_23, 8, _hoisted_20)
                ])
              ]),
              _: 1
            }, 8, ["onSubmit", "validation-schema"]))
          : (_openBlock(), _createBlock(_component_OtpInput, {
              loading: _ctx.loading,
              onSubmitOtp: _ctx.handleOtpSubmit,
              key: _ctx.otpKey
            }, null, 8, ["loading", "onSubmitOtp"]))
      ])
    ]),
    _hoisted_24
  ]))
}